module.exports = __webpack_public_path__ + "static/media/Avatars_Other-08.acabebe5.png";